"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageBase = void 0;

var ImageBase =
/** @class */
function () {
  function ImageBase() {}

  ImageBase.prototype.scaleDown = function (opts) {
    var width = this.getWidth();
    var height = this.getHeight();
    var ratio = 1;

    if (opts.maxDimension > 0) {
      var maxSide = Math.max(width, height);
      if (maxSide > opts.maxDimension) ratio = opts.maxDimension / maxSide;
    } else {
      ratio = 1 / opts.quality;
    }

    if (ratio < 1) this.resize(width * ratio, height * ratio, ratio);
  };

  ImageBase.prototype.applyFilter = function (filter) {
    var imageData = this.getImageData();

    if (typeof filter === 'function') {
      var pixels = imageData.data;
      var n = pixels.length / 4;
      var offset = void 0,
          r = void 0,
          g = void 0,
          b = void 0,
          a = void 0;

      for (var i = 0; i < n; i++) {
        offset = i * 4;
        r = pixels[offset + 0];
        g = pixels[offset + 1];
        b = pixels[offset + 2];
        a = pixels[offset + 3]; // Mark ignored color

        if (!filter(r, g, b, a)) pixels[offset + 3] = 0;
      }
    }

    return Promise.resolve(imageData);
  };

  return ImageBase;
}();

exports.ImageBase = ImageBase;